export enum AppIdEnum {
	UNKNOWN = 'unknown',

	BACKEND = 'backend', // APP Backend (komplett)
	BACKEND_DOCUMENTS = 'backend_documents', // APP Backend (Dokumentenmanagement)

	BACKEND_CONTRACT_NEW = 'backend_contract_new', // APP Backend (Neuer Arbeitsvertrag)
	BACKEND_CONTRACT_EDIT = 'backend_contract_edit', // APP Backend (Edit Arbeitsvertrag)

	BACKEND_REQUEST_EDIT = 'backend_request_edit', // APP Backend (Edit Messeanfrage)

	CONTRACT = 'contract', // APP Arbeitsvertrag

	REQUEST = 'request' // APP Messeanfrage
}
